import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import SidebarModal from 'components/consumer/SidebarModal';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import UpdateZipcodeForm from './UpdateZipcodeForm';
const UpdateZipcodeSidebar = t0 => {
  const $ = _c(9);
  const {
    onClose,
    isZipcodeFormOpen
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = t2 => {
      const shouldClose = t2 === undefined ? true : t2;
      if (shouldClose) {
        onClose?.();
      }
    };
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onUpdateSuccess = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-sm mb-[5px]">Enter your zip code so we can accurately estimate shipping to your location</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onUpdateSuccess) {
    t3 = <UpdateZipcodeForm onUpdateSuccess={onUpdateSuccess} />;
    $[3] = onUpdateSuccess;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isZipcodeFormOpen || $[6] !== onClose || $[7] !== t3) {
    t4 = <SidebarModal title="Update your location" isOpen={isZipcodeFormOpen} onClose={onClose}>{t2}{t3}</SidebarModal>;
    $[5] = isZipcodeFormOpen;
    $[6] = onClose;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
UpdateZipcodeSidebar.propTypes = {
  isZipcodeFormOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
export default withBrowserOnly(UpdateZipcodeSidebar);